import axios, { AxiosRequestConfig } from "axios";
import RequestAPI from "../..";
import StorageItems from "../../../storage";
import { base64ToBlob } from "../../../utils/filesFuncs";
import { generateMessageReturn } from "../../../utils/messageFuncs";

const auth = new StorageItems().get("authToken");

class ApiUsersPrivate extends RequestAPI {
  config: AxiosRequestConfig;
  data?: any;
  token;
  basePath = "usr/private";
  constructor(data?: any) {
    super();
    this.token = auth?.authToken;

    this.config = {
      maxBodyLength: Infinity,
      headers: {
        "Content-Type": "application/json",
        Authorization: this.token ? `Bearer ${this.token}` : "",
      },
    };

    if (data) {
      this.data = data;
      this.config.data = data;
    }
  }

  uploadAvatar = async (file: any) => {
    this.config.url = `${this.baseUrl}/${this.basePath}/avatar/upload/${this.data.id_usuario}`;
    this.config.method = "post";
    this.config.headers = {
      "Content-Type": "multipart/form-data",
      Authorization: this.token ? `Bearer ${this.token}` : "",
    };

    const formData = new FormData();

    if (file.startsWith("data:image/")) {
      const mimeType = file.match(/data:(.*);base64,/)[1]; // Extraia o tipo MIME
      const blob = base64ToBlob(file, mimeType); // Converte para Blob
      formData.append("file", blob, `${this.data.id_usuario}.jpg`); // Adicione ao FormData com um nome de arquivo
    }

    this.config.data = formData;
    this.result = await axios(this.config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        try {
          return error.response.data;
        } catch (errorCatch) {
          this.result.message = [
            generateMessageReturn(
              "Erro: Upload de Avatar",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });

    return this.result;
  };

  update = async (id: string) => {
    this.config.url = `${this.baseUrl}/${this.basePath}/update/${id}`;
    this.config.method = "post";

    this.result = await axios(this.config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        try {
          return error.response.data;
        } catch (errorCatch) {
          this.result.message = [
            generateMessageReturn(
              "Erro: Atualização de usuário",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });
    return this.result;
  };

  list = async () => {
    this.config.url = `${this.baseUrl}/${this.basePath}/list`;
    this.config.method = "get";

    this.result = await axios(this.config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        try {
          return error.response.data;
        } catch (errorCatch) {
          this.result.message = [
            generateMessageReturn(
              "Erro: Listagem de usuários",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });
    return this.result;
  };

  active = async (id: string) => {
    this.config.url = `${this.baseUrl}/${this.basePath}/active/${id}`;
    this.config.method = "get";

    this.result = await axios(this.config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        try {
          return error.response.data;
        } catch (errorCatch) {
          this.result.message = [
            generateMessageReturn(
              "Erro: Listagem de usuários",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });
    return this.result;
  };

  ban = async (id: string) => {
    this.config.url = `${this.baseUrl}/${this.basePath}/ban/${id}`;
    this.config.method = "get";

    this.result = await axios(this.config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        try {
          return error.response.data;
        } catch (errorCatch) {
          this.result.message = [
            generateMessageReturn(
              "Erro: Listagem de usuários",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });
    return this.result;
  };

  master = async (id: string) => {
    this.config.url = `${this.baseUrl}/${this.basePath}/master/${id}`;
    this.config.method = "get";

    this.result = await axios(this.config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        try {
          return error.response.data;
        } catch (errorCatch) {
          this.result.message = [
            generateMessageReturn(
              "Erro: Listagem de usuários",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });
    return this.result;
  };
}

export default ApiUsersPrivate;
